<template>
  <div>
    <div class="child-bg-image">
      <div class="bg-image-section" />
      <div class="content-section" />
    </div>
  </div>
</template>

  <script>
      export default {
          name: 'Reasone',
          components: {
          },
      };
  </script>

  <style scoped>

  </style>
